import React from 'react';
import { connect } from 'react-redux';
import { Heading6 } from '../../widgets';

const FarmName = props => props.currentFarm ?
    <Heading6 className="farm-info" >
        {props.currentFarm.farm_name}
    </Heading6 > : <></>;

const mapStateToProps = state => ({ currentFarm: state.farm.currentFarm });

export default connect(mapStateToProps)(FarmName);